import request from '@/utils/request'

// 充值列表
export function rechargeList(data) {
  return request({ url: '/webapi/capital/rechargeList', method: 'post', data })
}
// 退款列表
export function withdrawalList(data) {
  return request({ url: '/webapi/capital/withdrawalList', method: 'post', data })
}

// 是否处于审核阶段
export function getCompanyStatus(data) {
  return request({ url: '/webapi/company/getCompanyStatus', method: 'post', data })
}

// 获取充值详情
export function rechargeInfo() {
  return request({ url: '/webapi/capital/rechargeInfo', method: 'post' })
}

// 发起充值
export function rechargeAdd(data) {
  return request({ url: '/webapi/capital/rechargeAdd', method: 'post', data })
}

// 发起充值
export function interconvert(data) {
  return request({ url: '/webapi/capital/interconvert', method: 'post', data })
}

// 撤销充值
export function revokeRecharge(data) {
  return request({ url: '/webapi/capital/revokeRecharge', method: 'post', data })
}

// 极速到账
export function quicklyRecharge(data) {
  return request({ url: '/webapi/capital/quicklyRecharge', method: 'post', data })
}

// 退款信息
export function withdrawalInfo(data) {
  return request({ url: '/webapi/capital/withdrawalInfo', method: 'post', data })
}

// 发起退款
export function withdrawal(data) {
  return request({ url: '/webapi/capital/withdrawal', method: 'post', data })
}

// 撤销退款
export function revokeWithdrawal(data) {
  return request({ url: '/webapi/capital/revokeWithdrawal', method: 'post', data })
}

// 资金流水
export function capitalList(data) {
  return request({ url: '/webapi/capital/capitalList', method: 'post', data })
}

// 资金流水导出
export function capitalListout(data) {
  return request({ url: '/webapi/capital/capitalListout', method: 'post', data, responseType: 'blob' })
}

// 资金流水压缩包导出
export function orderCompress(data) {
  return request({ url: '/webapi/capital/orderCompress', method: 'post', data })
}

// 资金流水压缩包下载
export function download(params) {
  return request({ url: '/webapi/capital/download', method: 'get', params, responseType: 'blob' })
}

// 获取充值银行信息
export function getBankInfo() {
  return request({ url: '/webapi/capital/getBankInfo', method: 'get' })
}

// 获取充值记录详情
export function getRecharge(params) {
  return request({ url: '/webapi/capital/getRecharge', method: 'get', params })
}

// 获取充值记录详情
export function getWithdrawal(params) {
  return request({ url: '/webapi/capital/getWithdrawal', method: 'get', params })
}

// 获取充值记录详情
export function checkWithdrawal(data) {
  return request({ url: '/webapi/capital/checkWithdrawal', method: 'post', data })
}
